import { supabase } from '../../lib/supabase'

export class CardHashStorageService {
  private static instance: CardHashStorageService

  private constructor() {}

  public static getInstance(): CardHashStorageService {
    if (!CardHashStorageService.instance) {
      CardHashStorageService.instance = new CardHashStorageService()
    }
    return CardHashStorageService.instance
  }

  public async initDB(): Promise<void> {
    // Pas besoin d'initialisation spécifique pour Supabase
    return Promise.resolve()
  }

  public async storeHashes(hashes: { id: string; hash: string }[]): Promise<void> {
    if (hashes.length === 0) return Promise.resolve()

    // Convertir les ID en nombres pour correspondre à la base de données
    const hashesToStore = hashes.map(hash => ({
      card_id: parseInt(hash.id),
      hash: hash.hash
    }))

    // Traiter les hashes par lots
    const batchSize = 100
    for (let i = 0; i < hashesToStore.length; i += batchSize) {
      const batch = hashesToStore.slice(i, i + batchSize)

      // Insertion avec gestion des conflits - mise à jour si l'entrée existe déjà
      const { error } = await supabase
        .from('card_hashes')
        .upsert(
          batch,
          { 
            onConflict: 'card_id',
            ignoreDuplicates: false
          }
        )

      if (error) {
        console.error('Error storing card hashes in Supabase:', error)
        throw error
      }
    }
  }

  public async getAllHashes(): Promise<{ id: string; hash: string }[]> {
    const pageSize = 1000;
    let allHashes: { id: string; hash: string }[] = [];
    let page = 0;
    
    while (true) {
      const { data, error } = await supabase
        .from('card_hashes')
        .select('card_id, hash')
        .range(page * pageSize, (page + 1) * pageSize - 1);

      if (error) {
        console.error('Error fetching card hashes from Supabase:', error);
        throw error;
      }

      if (!data || data.length === 0) break;

      const formattedData = data.map(item => ({
        id: String(item.card_id),
        hash: item.hash
      }));

      allHashes = [...allHashes, ...formattedData];

      if (data.length < pageSize) break;
      page++;
    }

    return allHashes;
  }

  public async getHashCount(): Promise<number> {
    const { count, error } = await supabase
      .from('card_hashes')
      .select('*', { count: 'exact', head: true })

    if (error) {
      console.error('Error counting card hashes in Supabase:', error)
      throw error
    }

    return count || 0
  }
} 